
const Sizes = {
  small: "15px",
  medium: "18px",
  large: "22px",
};

export default Sizes;
